import Header from "./pages/Header";
import AddProductForm from "./productComponent/AddProductForm";
import { Routes, Route } from "react-router-dom";
import ContactUs from "./pages/ContactUs";
import AboutUs from "./pages/AboutUs";
import AddCategoryForm from "./productComponent/AddCategoryForm";
import HomePage from "./pages/HomePage";
import Product from "./pages/Product";
import AddUserForm from "./userComponent/AddUserForm";
import UserLoginForm from "./userComponent/UserLoginForm";
import MyCart from "./userComponent/MyCart";
import AddCardDetails from "./pages/AddCardDetails";
import MyOrder from "./userComponent/MyOrder";
import AllOrders from "./userComponent/AllOrders";
import SearchOrder from "./userComponent/SearchOrder";
import AdminLoginPage from "./userComponent/AdminLoginPage";
import AddDeliveryPerson from "./userComponent/AddDeliveryPerson";
import DeliveryPersonLogin from "./userComponent/DeliveryPersonLogin";
import AssignDeliveryToOrders from "./userComponent/AssignDeliveryToOrders";
import MyDeliveries from "./userComponent/MyDeliveries";
import ViewAllProducts from "./productComponent/ViewAllProducts";
import InventoryDashboard from "./InventoryComponent/InventoryDashboard";
import UpdateProductForm from "./productComponent/UpdateProductForm";
import ViewAllCustomers from "./userComponent/ViewAllCustomers";
import ViewAllCategories from "./productComponent/ViewAllCategories";
import CategorySizesPage from "./productComponent/CategorySizesPage";
import ViewAllSuppliers from "./userComponent/ViewAllSuppliers";
import UserProfile from "./userComponent/UserProfile";
import UserOtpVerification from "./userComponent/UserOtpVerification";
import ForgetPassOtpVerification from "./userComponent/ForgetPassOtpVerification";
import AdminProfile from "./userComponent/AdminProfile";
import DeliveryProfile from "./userComponent/DeliveryProfile";
import AddProductReview from "./ReviewComponent/AddProductReview";
import GetProductReviews from "./ReviewComponent/GetProductReviews";
import ForgetPassword from "./userComponent/ForgetPassword";
import AddDeliveryAddress from "./userComponent/AddDeliveryAddress";
import ViewDeliveryAddress from "./userComponent/ViewDeliveryAddress";
import DeliveryRoute from "./pages/DeliveryRoute";
import GuestCart from "./userComponent/GuestCart";
import ViewAllDeliveryPerson from "./userComponent/ViewAllDeliveryPerson";

function App() {
  return (
    <div>
      <Header />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/home" element={<HomePage />} />
        <Route path="/home/all/product/categories" element={<HomePage />} />
        <Route path="contact" element={<ContactUs />} />
        <Route path="about" element={<AboutUs />} />
        <Route path="addproduct" element={<AddProductForm />} />
        <Route path="addcategory" element={<AddCategoryForm />} />
        <Route path="/product" element={<Product />} />
        <Route path="/user/login" element={<UserLoginForm />} />
        <Route path="/user/admin/login" element={<AdminLoginPage />} />
        <Route
          path="/user/deliveryperson/register"
          element={<AddDeliveryPerson />}
        />
        <Route
          path="/user/deliveryperson/login"
          element={<DeliveryPersonLogin />}
        />
        <Route
          path="/home/product/category/:categoryId/:categoryName"
          element={<HomePage />}
        />
        <Route
          path="/product/:productId/category/:categoryId"
          element={<Product />}
        />
        <Route path="/user/mycart" element={<MyCart />} />
        <Route path="/user/order/payment" element={<AddCardDetails />} />
        <Route path="/user/myorder" element={<MyOrder />} />
        <Route path="/user/admin/allorder" element={<AllOrders />} />
        <Route path="/user/admin/searchOrder" element={<SearchOrder />} />
        <Route
          path="/user/admin/assigndelivery"
          element={<AssignDeliveryToOrders />}
        />
        <Route path="/user/delivery/myorders" element={<MyDeliveries />} />
        <Route path="/user/customer/register" element={<AddUserForm />} />
        <Route path="/user/admin/register" element={<AddUserForm />} />
        <Route path="/user/supplier/register" element={<AddUserForm />} />
        <Route path="/user/delivery/register" element={<AddUserForm />} />
        <Route path="/user/forget-password" element={<ForgetPassword />} />
        <Route path="/admin/product/all" element={<ViewAllProducts />} />
        <Route
          path="/admin/inventory/dashboard"
          element={<InventoryDashboard />}
        />
        <Route path="/admin/product/update" element={<UpdateProductForm />} />
        <Route path="/admin/customer/all" element={<ViewAllCustomers />} />
        <Route path="/admin/supplier/all" element={<ViewAllSuppliers />} />
        <Route path="/admin/delivery/all" element={<ViewAllDeliveryPerson />} />
        <Route path="/admin/category/all" element={<ViewAllCategories />} />
        <Route path="/admin/category/sizes" element={<CategorySizesPage />} />
        <Route path="/user/profile" element={<UserProfile />} />
        <Route path="/delivery/profile" element={<DeliveryProfile />} />
        <Route path="/admin/profile" element={<AdminProfile />} />
        <Route path="/user/forget-password" element={<ForgetPassword />} />
        <Route path="/user/verify/register" element={<UserOtpVerification />} />
        <Route
          path="/user/verify/forget"
          element={<ForgetPassOtpVerification />}
        />
        <Route
          path="/product/:productId/review/add"
          element={<AddProductReview />}
        />
        <Route path="/product/review/fetch" element={<GetProductReviews />} />
        <Route path="/delivery/address/add" element={<AddDeliveryAddress />} />
        <Route
          path="/delivery/address/view"
          element={<ViewDeliveryAddress />}
        />
        <Route
          path="/delivery/route/:latitude/:longitude"
          element={<DeliveryRoute />}
        />
        <Route path="/guest/cart" element={<GuestCart />} />
      </Routes>
    </div>
  );
}

export default App;
